import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface TradingPageSecurityCardClickedProps extends EventProps {
    securityCode?: string
    securityName?: string
    price?: number
    changeInPriceYTD?: number
    revenueSource?: string[]
    numPositiveTags?: number
    numNegativeTags?: number
}

/**
 * @event TradingPageSecurityCard Clicked
 * @description Emitted when a security card on the trading/find stocks page is clicked.
 */
export const TradingPageSecurityCardClickedAnalytics = createAnalyticsStatic<TradingPageSecurityCardClickedProps>(
    ANALYTICS_EVENTS.TRADING.TRADING_PAGE_SECURITY_CARD_CLICKED,
)

export default TradingPageSecurityCardClickedAnalytics
